"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchers = void 0;
var tenderActions = require("@caddigital/sok-reducers/lib/actions/bid/tender");
var mapDispatchers = function (dispatch) { return ({
    approveSection: function (currentBid, participant, section) {
        return dispatch(tenderActions.approveSectionRequest(currentBid, participant, section));
    },
    declineSection: function (currentBid, participant, section) {
        return dispatch(tenderActions.declineSectionRequest(currentBid, participant, section));
    }
}); };
exports.mapDispatchers = mapDispatchers;
